import React from 'react';

export const SubText: React.FC = ({ children, ...otherProps }) => (
  <p className="text-xl text-gray-400 mb-8" {...otherProps}>
    {children}
  </p>
);
